<div class="mobile-venta-container">
  <header class="mobile-header" mat-elevation-z4>
    <button
      mat-icon-button
      class="back-button"
      type="button"
      aria-label="Regresar"
      (click)="toggleView('search')"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span> Registrando Venta</span>
    <div class="header-actions">
      <button mat-icon-button (click)="toggleView('search')" [class.active]="currentView === 'search'">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-icon-button (click)="toggleView('cart')" [class.active]="currentView === 'cart'">
        <mat-icon>shopping_cart</mat-icon>
        <span class="cart-badge" *ngIf="productosEnVenta.length > 0">
          {{ productosEnVenta.length }}
        </span>
      </button>
      <button mat-icon-button (click)="toggleView('payment')" [class.active]="currentView === 'payment'">
        <mat-icon>payments</mat-icon>
      </button>
    </div>
  </header>

  <section class="status-strip" *ngIf="productosEnVenta.length > 0">
    <div class="status-item">
      <mat-icon>shopping_bag</mat-icon>
      <span>{{ productosEnVenta.length }} productos</span>
    </div>
    <div class="status-item">
      <mat-icon>attach_money</mat-icon>
      <span>{{ ventaForm.get('total')?.value | currency }}</span>
    </div>
    <button mat-stroked-button color="primary" (click)="toggleView('payment')">
      Ir a Cobrar
    </button>
  </section>

  <main class="mobile-content">
    <section class="view" [class.active]="currentView === 'search'">
      <mat-card class="mobile-card">
        <mat-card-content>
          <mat-form-field appearance="fill" class="full-width floating-field">
            <mat-label>Buscar producto</mat-label>
            <input
              matInput
              [(ngModel)]="searchTerm"
              (keyup)="onSearch()"
              placeholder="Código, nombre o descripción"
              autocomplete="off"
            />
            <button
              *ngIf="searchTerm"
              mat-icon-button
              matSuffix
              type="button"
              (click)="searchTerm = ''; mostrarSugerencias = false"
              aria-label="Limpiar búsqueda"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-icon matSuffix *ngIf="!searchTerm">search</mat-icon>
          </mat-form-field>

          <div class="helper-text">
            <mat-icon>lightbulb</mat-icon>
            <span>Escribe al menos dos caracteres para obtener coincidencias.</span>
          </div>

          <div class="search-results" *ngIf="mostrarSugerencias">
            <div class="loading-overlay" *ngIf="buscando">
              <mat-spinner diameter="36"></mat-spinner>
              <p>Buscando productos...</p>
            </div>

            <ng-container *ngIf="!buscando">
              <div
                class="product-item"
                *ngFor="let producto of productosEncontrados"
                [class.out-of-stock]="producto.stock <= 0"
                (click)="agregarProductoDirecto(producto)"
                role="button"
                tabindex="0"
                (keydown.enter)="agregarProductoDirecto(producto)"
                (keydown.space)="agregarProductoDirecto(producto); $event.preventDefault()"
              >
                <div class="product-leading" [class.out]="producto.stock <= 0">
                  <mat-icon>{{ producto.stock > 0 ? 'inventory_2' : 'report' }}</mat-icon>
                </div>

                <div class="product-detail">
                  <div class="product-title">
                    <span class="name">{{ producto.nombre }}</span>
                    <span class="price">
                      <mat-icon>attach_money</mat-icon>
                      {{ producto.precio | number }}
                    </span>
                  </div>
                  <div class="product-meta">
                    <span class="code">
                      <mat-icon>qr_code</mat-icon>
                      {{ producto.codigo }}
                    </span>
                    <span class="stock" [class.low]="producto.stock <= 0">
                      <mat-icon>inventory</mat-icon>
                      Stock: {{ producto.stock }}
                    </span>
                  </div>
                </div>

                <div class="product-actions">
                  <button
                    mat-stroked-button
                    color="primary"
                    (click)="verDetallesProducto(producto); $event.stopPropagation()"
                    type="button"
                  >
                    Ver detalles
                  </button>
                  <mat-icon class="add-icon">add_circle</mat-icon>
                </div>
              </div>

              <div
                class="no-results"
                *ngIf="productosEncontrados.length === 0 && searchTerm.length >= 2"
              >
                <mat-icon>sentiment_dissatisfied</mat-icon>
                <p>No se encontraron productos con tu búsqueda.</p>
                <small>Verifica el código o el nombre e inténtalo nuevamente.</small>
              </div>
            </ng-container>
          </div>
        </mat-card-content>
      </mat-card>
    </section>

    <section class="view" [class.active]="currentView === 'cart'">
      <mat-card class="mobile-card" *ngIf="productosEnVenta.length > 0; else emptyCart">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>shopping_cart_checkout</mat-icon>
            Carrito ({{ productosEnVenta.length }})
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="cart-items">
            <article class="cart-item" *ngFor="let producto of productosEnVenta; let i = index">
              <div class="item-header">
                <div class="item-tag">{{ producto.codigo }}</div>
                <button mat-icon-button color="warn" (click)="eliminarProducto(i)" aria-label="Eliminar producto">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>

              <div class="item-body">
                <h4>{{ producto.nombre }}</h4>
                <div class="item-meta">
                  <span class="item-price">
                    <mat-icon>attach_money</mat-icon>
                    {{ producto.precio | number }} c/u
                  </span>
                  <span class="item-stock">
                    <mat-icon>inventory</mat-icon>
                    Disponible: {{ producto.stock }}
                  </span>
                </div>

                <div class="item-controls">
                  <div class="quantity-controls" mat-elevation-z2>
                    <button
                      mat-mini-fab
                      color="primary"
                      (click)="actualizarCantidad(producto, producto.cantidad - 1)"
                      [disabled]="producto.cantidad <= 1"
                    >
                      <mat-icon>remove</mat-icon>
                    </button>
                    <span class="quantity">{{ producto.cantidad }}</span>
                    <button
                      mat-mini-fab
                      color="primary"
                      (click)="actualizarCantidad(producto, producto.cantidad + 1)"
                      [disabled]="producto.cantidad >= producto.stock"
                    >
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>

                  <div class="discount-toggle">
                    <mat-checkbox 
                      [checked]="mostrarDescuento(producto)"
                      (change)="toggleDescuento(producto)"
                      color="primary">
                      <span class="discount-toggle-label">
                        <mat-icon>local_offer</mat-icon>
                        Descuento
                        <span *ngIf="producto.descuento > 0" class="discount-badge">
                          -{{ producto.descuento | currency }}
                        </span>
                      </span>
                    </mat-checkbox>
                  </div>

                  <div class="discount-control" *ngIf="mostrarDescuento(producto)">
                    <mat-form-field appearance="outline" class="discount-field-mobile">
                      <mat-label>Monto descuento</mat-label>
                      <input matInput type="number" 
                             [value]="producto.descuento || 0"
                             (blur)="actualizarDescuento(producto, $any($event.target).value)"
                             min="0"
                             [max]="producto.cantidad * producto.precio"
                             step="0.01">
                      <span matPrefix>$&nbsp;</span>
                    </mat-form-field>
                  </div>

                  <div class="item-subtotal">
                    <span>Subtotal</span>
                    <strong>{{ producto.subtotal | currency }}</strong>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </mat-card-content>
      </mat-card>

      <ng-template #emptyCart>
        <div class="empty-state">
          <mat-icon>shopping_cart</mat-icon>
          <h3>Tu carrito está vacío</h3>
          <p>Busca un producto o escanea su código para empezar una nueva venta.</p>
          <button mat-stroked-button color="primary" (click)="toggleView('search')">
            Explorar productos
          </button>
        </div>
      </ng-template>
    </section>

    <section class="view" [class.active]="currentView === 'payment'">
      <mat-card class="mobile-card payment-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>fact_check</mat-icon>
            Finalizar venta
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="processing-overlay" *ngIf="isLoading">
            <mat-spinner diameter="36"></mat-spinner>
            <span>Registrando venta...</span>
          </div>
          <div class="payment-summary">
            <div class="summary-card" mat-elevation-z2>
              <div class="summary-row">
                <span>Subtotal</span>
                <strong>{{ calcularSubtotal() | currency }}</strong>
              </div>
              <div class="summary-row" *ngIf="calcularTotalDescuentos() > 0">
                <span>Descuentos</span>
                <strong style="color: #f44336;">-{{ calcularTotalDescuentos() | currency }}</strong>
              </div>
              <div class="summary-row">
                <span>IVA (16%)</span>
                <strong>{{ 0 | currency }}</strong>
              </div>
              <div class="summary-row total">
                <span>Total a cobrar</span>
                <strong>{{ ventaForm.get('total')?.value | currency }}</strong>
              </div>
            </div>
          </div>

          <form [formGroup]="ventaForm" class="payment-form">
            <mat-checkbox formControlName="esApartado" (change)="calcularCambio()" class="full-width apartado-checkbox-mobile">
              <span class="apartado-label">
                <mat-icon>schedule</mat-icon>
                Esta venta es un apartado
              </span>
            </mat-checkbox>

            <div class="apartado-info-mobile" *ngIf="ventaForm.get('esApartado')?.value">
              <mat-icon>info</mat-icon>
              <span>La venta quedará como pendiente hasta completar el pago</span>
            </div>

            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Método de Pago</mat-label>
              <mat-select formControlName="metodoPago">
                <mat-option *ngFor="let m of metodosPago" [value]="m">
                  {{ metodoPagoLabels[m] }}
                </mat-option>
              </mat-select>
              <mat-icon matSuffix>credit_card</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Dinero recibido</mat-label>
              <input matInput type="number" formControlName="dineroRecibido" (input)="calcularCambio()" min="0" />
              <span matPrefix>$&nbsp;</span>
              <mat-icon matSuffix>payments</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="fill" class="full-width">
              <mat-label>{{ ventaForm.get('esApartado')?.value ? 'Saldo Pendiente' : 'Cambio' }}</mat-label>
              <input matInput formControlName="cambio" readonly />
              <span matPrefix>$&nbsp;</span>
              <mat-icon matSuffix>{{ ventaForm.get('esApartado')?.value ? 'pending' : 'sync_alt' }}</mat-icon>
              <mat-hint *ngIf="ventaForm.get('esApartado')?.value && ventaForm.get('cambio')?.value < 0">
                Faltan {{ (ventaForm.get('cambio')?.value * -1) | currency }} por pagar
              </mat-hint>
            </mat-form-field>

            <div class="ticket-options" style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 16px;">
              <mat-checkbox [(ngModel)]="generarPdf" [ngModelOptions]="{standalone: true}" color="primary">
                Generar PDF para compartir
              </mat-checkbox>
              <mat-checkbox [(ngModel)]="generarTicketImpresora" [ngModelOptions]="{standalone: true}" color="primary">
                Generar ticket para impresora (Texto)
              </mat-checkbox>
            </div>

            <button
              mat-raised-button
              color="primary"
              class="full-width payment-button"
              (click)="generarTicket()"
              [disabled]="!puedeGenerarTicket() || isLoading"
              type="button"
            >
              <span class="generate-button-content">
                <mat-spinner *ngIf="isLoading" diameter="18"></mat-spinner>
                <mat-icon *ngIf="!isLoading">{{ ventaForm.get('esApartado')?.value ? 'schedule' : 'receipt_long' }}</mat-icon>
                <span>{{ isLoading ? 'Registrando...' : (ventaForm.get('esApartado')?.value ? 'Registrar Apartado' : 'Generar ticket') }}</span>
              </span>
            </button>
          </form>
        </mat-card-content>
      </mat-card>
    </section>
  </main>

  <footer class="mobile-footer" *ngIf="productosEnVenta.length > 0">
    <div class="footer-total">
      <span>Total:</span>
      <strong>{{ ventaForm.get('total')?.value | currency }}</strong>
    </div>
    <div class="footer-actions">
      <button
        mat-stroked-button
        color="primary"
        class="secondary-action"
        (click)="toggleView(currentView === 'cart' ? 'search' : 'cart')"
      >
        <mat-icon>{{ currentView === 'cart' ? 'add_circle' : 'shopping_cart' }}</mat-icon>
        {{ currentView === 'cart' ? 'Agregar más productos' : 'Ver carrito' }}
      </button>
      <button mat-flat-button color="primary" class="primary-action" (click)="toggleView('payment')">
        <mat-icon>bolt</mat-icon>
        Cobrar ahora
      </button>
    </div>
  </footer>
</div>
